import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({ providedIn: 'root' })
export class EnvioMasivoService {

  constructor(
    private http: HttpClient,
    private api: ApiService
  ) {}

  /**
   * Resumen de pendientes agrupados por fecha (cantidad y saldo por día + totales generales).
   */
  listarPendientesResumen(_token: string, params: { fechaInicio: string; fechaFin: string }) {
    return this.api.post<any>(
      '/transactions/electronic-documents/pending/summary',
      params
    );
  }

  /**
   * Obtiene del backend Node la lista de documentos pendientes de envío al SRI
   * dentro de un rango de fechas (incluye claveFactura y EMA_CLI por documento).
   */
  listarPendientes(_token: string, params: { fechaInicio: string; fechaFin: string }) {
    return this.api.post<any>(
      '/transactions/electronic-documents/pending/list',
      params
    );
  }

  /**
   * Envía un documento al SRI a través del backend Node API v1.
   */
  enviarSRI(token: string, claveAcceso: string, email: string, nombre: string) {
    return this.api.post<{ sri: { status: string; number?: string; authorizedAt?: string } }>(
      '/transactions/electronic-documents/send-sri',
      { claveAcceso }
    ).pipe(
      map(({ sri }) => {
        const status = sri?.status || 'authorized';
        return status === 'authorized'
          ? 'Autorizado'
          : `Enviado al SRI con estado ${status}`;
      }),
      catchError(e => {
        throw e;
      })
    );
  }
}
